import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const tabSkeletons = Array.from({ length: 5 }).map((_, index) => (
    <PixelPlaceholderLoader
        key={index}
        width={124}
        height={20}
    />
));

export const HighLevelMetricsComparisonWidgetSkeleton = () => {
    return (
        <Stack width="100%">
            <Flex
                height="50px"
                gap="40px"
                alignItems="center"
            >
                {tabSkeletons}
            </Flex>
            <Flex
                height="40px"
                marginY="24px"
            >
                <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                >
                    <Flex gap="24px">
                        <PixelPlaceholderLoader
                            width={160}
                            height={20}
                        />
                        <PixelPlaceholderLoader
                            width={160}
                            height={20}
                        />
                    </Flex>
                    <Flex gap="8px">
                        <PixelPlaceholderLoader
                            width={120}
                            height={40}
                        />
                        <PixelPlaceholderLoader
                            width={40}
                            height={40}
                        />
                    </Flex>
                </Flex>
            </Flex>
            <Flex padding="0 0 8px 0">
                <PixelPlaceholderLoader
                    width="100%"
                    height={280}
                />
            </Flex>
        </Stack>
    );
};
